<template>
    <div>
        <el-upload
            ref="upload"
            :auto-upload="true"
            :data="access"
            :action="action"
            accept=".zip,.rar,.7z,"
            :multiple="true"
            :before-upload="beforeUpload"
            :on-remove="onRemoveHandler"
            :before-remove="beforeRemove"
            :on-success="onSuccessHandler"
            :on-error="onError"
            :show-file-list="true"
            :on-preview="handlePreview"
            :disabled="IsUpload == false"
            :on-exceed="fileLimit"
            :limit="1"
            :file-list="fileLists"
        >
            <el-button type="primary" size="small" v-if="IsUpload">点击上传</el-button>
            <a href="" style="display: none;"></a>
        </el-upload>
    </div>
</template>

<script>
import uploader from "lib/mixins/uploader";
export default {
    mixins: [uploader],
    props: {
        IsUpload: {
            type: Boolean,
            default: true,
        },
        fileLists: {
            type: Array,
            default: () => {
                return [];
            },
        },
        IsPreview: {
            type: Boolean,
            default: false,
        },
        files: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            docId: "",
            sourceFiles: [],
            materialids: [],
            imgsList: [],
            imgUrl: "",
            indexCount: 0,
            docId: "",
        };
    },
    created() {
    },
    methods: {
        dialogClose() {
            this.dialogVisiblePreviewResources = false;
        },
        uploadFile() {},
        fileLimit() {
            this.$message.warning("一次最多上传1个文件");
        },
        beforeUpload(file) {
            const ext = file.name.split(".").pop();
            return ["zip", "rar", "7z"].includes(ext) && this.addFile(file);
        },
        onRemoveHandler(file) {
            let obj = {};
            this.$emit("remove", obj);
        },
        beforeRemove(file, fileList) {},
        handlePreview(file) {
            const a = document.createElement('a');
            a.setAttribute('download', file.name);
            a.setAttribute('href', file.url);
        },
        onSuccessHandler(res, file, uploadFiles) {
            this.IsShowUpload = false;
            // 执行mixins里的onSuccess, 继续下一个文件
            if (this.onSuccess) {
                this.onSuccess(res, file, uploadFiles);
            }
            if (res.code > 0) {
                file.url = res.docPath;
            }
            let obj = {
                docId: res.docId,
                url: res.docPath,
                name: res.fileName
            }
            console.log(obj)
            this.materialids.push(res.docId);
            this.$emit("done", obj);
        },
    },
};
</script>

<style lang="scss">
.PreviewResourcces {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2010;
    background-color: rgba(0, 0, 0, 1);
    width: 100%;
    height: 100%;
    overflow: auto;
    .icon-closeimg {
        size: 26px;
        position: fixed;
        top: 20px;
        right: 20px;
        font-size: 35px;
        cursor: pointer;
        font-weight: bolder;
    }
}
.el-col-8 {
    margin-top: 15px;
    width: 100%;
}
.preview-class-content {
    max-width: 100%;
}
</style>
